<template>
  <FieldContainer
    class="RegionInput"
    v-bind="{ title, optional, error }"
    :data-testing-target="`Field: ${name}`"
  >
    <div class="selectWrapper">
      <select v-bind="{ name }" autocomplete="off" class="input">
        <option value="">{{ placeholder }}</option>
        <option v-for="region in regions"
          :key="region.shortCode"
          :value="region.name"
          :selected="region.name == value"
        >
          {{ region.name }}
        </option>
      </select>
    </div>
  </FieldContainer>
</template>

<!--
NOTE that the <select> 'input' and 'change' events aren't handled here. Instead they
bubble up to Slide, which updates the fields based on the <input> name and value.
-->

<script>
import getCountryData from '../../../../lib/countryData.js'

import FieldContainer from './FieldContainer.vue'

export default {
  inject: ['locale'],  // Required for getCountryData() below.
  components: {
    FieldContainer,
  },
  props: {
    name: String,
    placeholder: String,
    title: String,
    value: String,
    error: String,
    optional: Boolean,
    disabled: Boolean,
  },
  computed: {
    regions() {
      const fallbackLocale = this.locale
      return getCountryData(fallbackLocale)?.regions
    },
  },
}
</script>

<style scoped>
.selectWrapper {
  position: relative;
}
.selectWrapper::after {
  content: url('../../assets/select-expand.svg');
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: var(--spacing-3);
  height: 100%;
  pointer-events: none;
}
.input {
  padding: var(--spacing-2) var(--spacing-3);
  display: block;
  width: 100%;
  appearance: none;
  background: none;
  border-style: none;
}
.input:focus-visible {
  outline: none;
}
</style>
